export default __webpack_public_path__ + "static/media/welcome-bg9.0c36d6f0.png";